<template>
  <a-input
    v-model:value="innerValue"
    :placeholder="placeholder"
    :disabled="disabled"
    :size="size"
    :allow-clear="allowClear"
    :maxlength="maxlength"
    :status="status"
    class="ant-address-input"
    @blur="onBlur"
    @pressEnter="onPressEnter"
  >
    <template #prefix>
      <i class="fas fa-map-marker-alt" />
    </template>
  </a-input>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import type { SizeType } from "ant-design-vue/es/config-provider";

interface Props {
  modelValue?: string;
  placeholder?: string;
  disabled?: boolean;
  size?: SizeType;
  allowClear?: boolean;
  maxlength?: number;
  status?: "" | "error" | "warning";
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: "",
  placeholder: "Số nhà, tên đường...",
  disabled: false,
  size: "middle",
  allowClear: true,
  maxlength: 255,
  status: "",
});

const emit = defineEmits<{
  (e: "update:modelValue", value: string): void;
  (e: "change", value: string): void;
  (e: "blur", event: FocusEvent): void;
  (e: "pressEnter", event: KeyboardEvent): void;
}>();

const innerValue = computed({
  get: () => props.modelValue ?? "",
  set: (val: string) => {
    emit("update:modelValue", val);
    emit("change", val);
  },
});

const onBlur = (e: FocusEvent) => emit("blur", e);
const onPressEnter = (e: KeyboardEvent) => emit("pressEnter", e);
</script>

<!--
  Hướng dẫn sử dụng — Address Input
  Global: <h-address v-model="address" />
  Import: import { AddressInput } from '@/components/ant/address'

  Props: modelValue, placeholder, disabled, size, allowClear, maxlength, status
  Events: update:modelValue, change, blur, pressEnter
  Docs: src/components/ant/address/README.md
-->
